import React, { Component } from "react";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Grid from '@material-ui/core/Grid';

import Event from './modules/Event'
import './index.css';
import Utils from './modules/Utils';

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
    eventData:[], // Data Eventů pro rezervace
    }
  }

    
  // Iniciální načtení dat
  componentDidMount() {
    this.getEvents();    //Poprvé hned aby se nečekalo v count   
    this.interval = setInterval(() => this.getEvents(), 5000); //5sec.
    }
    
  componentWillUnmount() {
    clearInterval(this.interval);
    }


  // Refresh po zadání hodnoty
  handleRefresh = () => {
    this.getEvents();
  };


  // Načtení pole osazenosti mše
  getEvents(){

    var formData = new FormData();
        formData.append('getEvents', true); // Metoda getReservations
     
      let fetchData = { 
        method: 'POST', body: formData,      
        headers: {
           headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        },  
      }

    // A posílám
    fetch(Utils.getURL(), fetchData)   
    .then(response => response.json())
    .then(data => {          
        if ( data["success"]) {
        // Načtení data.data do tabulky
            if ( data["count"] > 0) {
              this.setState({eventData: data.data }); // Po přihlášení na hlavní stránku                    
            }
            else {
              this.setState({eventData: [] }); // Po přihlášení na hlavní stránku                    
            }        
        
        // console.log('Stav:', "OK");  
      }
        else{
          console.error('Chyba:', "Nejsou data");
              }            
    })
    .catch((error) => {
      console.error('Chyba:', error);
    });    
}

  render() { 
    return (
      <div >        
        <AppBar position="sticky">
      {/* <AppBar position="static"> */}
                <Toolbar>
                  <IconButton edge="start" color="inherit" 
                    onClick={() => { 
                      window.location.href='http://augustinbrno.cz'; } }                                   
                      aria-label="menu">
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography className="modulename" variant="h6" >
                  Přihlášení na ADORAČNÍ DEN FARNOSTI - neděle 22.11.2020
                  </Typography> 
                                  
                </Toolbar>
      </AppBar>
      <div className="info">
      <br></br> 
      Vyberte neobsazenou půlhodinu a stiskněte tlačítko <b>"Přihlásit"</b>.<br></br> 
      Pokud neuvidíte žádné tlačítko "Přihlásit", je již vše obsazené.  <br></br> 
      <br></br>
      </div>
      
    <Grid container spacing={0}>
        {this.state.eventData.map((item, index) =>
          <Grid item xs={12} sm={12} md={12} lg={12} >                
                
            <Event 
              myId ={item.ad_id} 
              myTime={item.ad_time}
              myPerson={item.ad_person}
              myValid={item.ad_valid}
              
              // Předání fce pro refresh
              
              onRefresh={() => this.handleRefresh()} 
                    

              > 
            </Event>
        </Grid>
          )
        }

      </Grid> {/* Hlavní grid */}
      <br></br>
      <div className="info">
      Pokud se rozhodnete zrušit svou účast, napište mail na <a href="mailto:%20karel.kallab@gmail.com">webmaster@augustinbrno.cz</a>
      <br></br><br></br>
      </div>
      <footer>
        <Typography variant="body2" color="textSecondary" align="center">
        { 'v1.01 Copyright © KAK 2020'}      
        </Typography>
        </footer>
      </div>
    );
  }
}

export default App;